import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { UserProvider } from './contexts/user.context';
import App from './App';
import './index.css';
import { GlobalSurveysProvider } from './contexts/global-surveys.context';
import { JuneProvider } from './contexts/analytics.context';
import { Notifications } from '@mantine/notifications';
import { MantineProvider } from '@mantine/core';
import ChatwootWidget from './components/chatwoot-widget/chatwoot-widget.component';

const getButtonHoverColor = (variant, color, themeColors) => {
  if (variant === 'subtle') {
    if (color === 'red') {
      return themeColors.red[0];
    }
    return themeColors.gray[0];
  }
  if (variant === 'white') {
    return themeColors.gray[5];
  }
  if (variant === 'filled') {
    return themeColors.gray[8];
  }
  return undefined;
}

const customTheme = {
  breakpoints: {
    xs: 500,
    sm: 800,
    md: 1000,
    lg: 1200,
    xl: 1400,
    xxl: 2000,
  },
  fontFamily: 'Inter',
  primaryColor: 'dark',
  components: {
    Input: {
      // Subscribe to theme and component params
      styles: (theme, params) => ({
        input: {
          border: params.variant === 'default' ? `1px solid ${theme.colors.gray[3]}` : 'undefined',
          // '&:focus': { 
          //   border: params.variant === 'default' ? `2px solid ${theme.colors.gray[6]}` : 'undefined'
          // }
        }
      })
    },
    Button: {
      styles: (theme, params, {variant}) => ({
        root: {
          fontWeight: 500,
          '&:hover': { background: getButtonHoverColor(variant, params.color, theme.colors) }
        }
      })
    },
    Title: {
      styles: (theme, params) => ({
        root: {
          fontFamily: 'Inter',
        }
      })
    }
  },
  colors: {
    'white': ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'],
  }
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Helmet>
      <title>Roundtable | AI-Powered Market Research</title>
      <meta
        name='description'
        content='Roundtable offers a simple API for identifying survey fraud, inattentive participants, and bad actors.'
      />
    </Helmet>
    <UserProvider>
      <GlobalSurveysProvider>
        <JuneProvider>
          <MantineProvider withGlobalStyles withNormalizeCSS theme={customTheme}>
            <Notifications position="top-center" />
            <ChatwootWidget />
            <App />
          </MantineProvider>
        </JuneProvider>
      </GlobalSurveysProvider>
    </UserProvider>
  </BrowserRouter>
  //</React.StrictMode>
);